const DoingContainer = ({ doing }) => {
    const { Icon, Title, Description } = doing;

    return (
        <div
            className="flex items-start gap-4 p-4 rounded-xl transition-all duration-200"
            style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(200,151,42,0.05)";
                e.currentTarget.style.borderColor = "rgba(200,151,42,0.2)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
            }}
        >
            {/* Icon */}
            <div
                className="flex-shrink-0 flex items-center justify-center rounded-lg"
                style={{
                    width: "42px",
                    height: "42px",
                    background: "rgba(200,151,42,0.1)",
                    border: "1px solid rgba(200,151,42,0.2)",
                    color: "#C8972A",
                }}
            >
                {Icon}
            </div>

            {/* Text */}
            <div>
                <p
                    className="font-semibold text-white mb-1"
                    style={{ fontSize: "14px" }}
                >
                    {Title}
                </p>
                <p
                    className="text-gray-400 leading-relaxed"
                    style={{ fontSize: "12px" }}
                >
                    {Description}
                </p>
            </div>
        </div>
    );
};

export default DoingContainer;
